module.exports = __webpack_public_path__ + "static/media/cover_maths_5_6_degree.c5f2a107.jpg";